import { Row } from 'components-antd';
import Slider from 'react-slick';

import { ListedWidget } from './ListedWidget';
import { UnderContractWidget } from './UnderContractWidget';
import { ClientWidget } from './ClientWidget';
import { ExpiringListingWidget } from './ExpiringListingWidget';
import { ClosingWidget } from './ClosingWidget';
import { ClosedWidget } from './ClosedWidget';

import styles from './styles.module.scss';
import { ArrowLeft, ArrowRight } from 'components/Icons';
import classNames from 'classnames';

const CarouselNext = (props) => {
  const { onClick, className } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowLeft className={styles.icon} />
    </div>
  );
};

const CarouselPrev = (props) => {
  const { onClick, className } = props;
  return (
    <div className={className} onClick={onClick}>
      <ArrowLeft className={styles.icon} />
    </div>
  );
};

export const PulseDashboardWidgets = ({ teamStats }) => {
  const settings = {
    draggable: true,
    accessibility: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 2.5,
    nextArrow: <CarouselNext className={styles.arrows} />,
    prevArrow: <CarouselPrev className={styles.arrows} />,

    initialSlide: 0,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 4.3, slidesToScroll: 2.7 } },
      {
        breakpoint: 900,
        settings: { slidesToShow: 2.5, slidesToScroll: 1.8 },
      },
      {
        breakpoint: 700,
        settings: { slidesToShow: 2.2, slidesToScroll: 2 },
      },

      {
        breakpoint: 500,
        settings: { slidesToShow: 1.8, slidesToScroll: 2 },
      },
    ],
  };

  return (
    <div className={classNames(styles.pulseWidgetsSliderContainer, styles.scrollable)}>
      <Slider {...settings} className={styles.widgetsSlider}>
        <div className={styles.cardContainer}>
          <ListedWidget teamStats={teamStats} />
        </div>

        <div className={styles.cardContainer}>
          <UnderContractWidget teamStats={teamStats} />
        </div>

        <div className={styles.cardContainer}>
          <ClosingWidget teamStats={teamStats} />
        </div>

        <div className={styles.cardContainer}>
          <ExpiringListingWidget teamStats={teamStats} />
        </div>

        <div className={styles.cardContainer}>
          <ClientWidget teamStats={teamStats} />
        </div>

        <div className={styles.cardContainer}>
          <ClosedWidget teamStats={teamStats} />
        </div>
      </Slider>
    </div>
  );
};
